import { render, staticRenderFns } from "./LaunchTalk.vue?vue&type=template&id=28b20aa8&scoped=true"
import script from "./LaunchTalk.vue?vue&type=script&lang=js"
export * from "./LaunchTalk.vue?vue&type=script&lang=js"
import style0 from "./LaunchTalk.vue?vue&type=style&index=0&id=28b20aa8&prod&lang=stylus&scoped=true"
import style1 from "./LaunchTalk.vue?vue&type=style&index=1&id=28b20aa8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b20aa8",
  null
  
)

export default component.exports